import * as findLastIndex from "array.prototype.findlastindex";
import flatMap from "array.prototype.flatmap";
import AggregateError from "es-aggregate-error";
import globalThis from "globalthis";
import fromEntries from "object.fromentries";
import promiseAny from "promise.any";
import replaceAll from "string.prototype.replaceall";

export function shim() {
  flatMap.shim();
  AggregateError.shim();
  globalThis.shim();
  fromEntries.shim();
  promiseAny.shim();
  findLastIndex.shim();
  replaceAll.shim();
}
